export { AllActionTypes as ActionTypes } from "./actionTypes";
export { AllMutationTypes as MutationTypes } from "./mutationTypes";
export { AllGetterTypes as GetterTypes } from "./gettersTypes";

export { store } from "./store";
import { store } from "./store";

export default store;
